<div class="directionLtr" [id]="name" [style.width.%]="100" [style.height.px]="330"></div>